import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交审批")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重新审批")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("发送通知")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("提交审批")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("发送通知")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import { categoryMap } from '@/views/typeMapping/HumanReousces'
import { formatNumber, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  emits: ['ToContract'],
  setup(__props, { emit: emits }) {

let {
  // 首页查看获取最新合同
  'POST/labor_contracts/home_page/query': fetchList,
  // 通用文件流下载
  'GET/upload/download': downloadApi,
  // 获取审批状态
  'GET/labor_contracts/drop_list/approval_status': approval_statusApi,
  // 提交审批
  'POST/labor_contracts/home_page/submit_approval': submit_approvalApi,
  // 重新发起审批
  'POST/labor_contracts/home_page/reapproval': reapprovalApi,
} = Api


const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let statusList: any = ref([])
let statusMap: any = reactive({})
onBeforeMount(() => {
  approval_statusApi().then((rep: any) => {
    Object.assign(statusMap, rep)
    statusList.value = []
    for (const key in rep) {
      statusList.value.push({ label: rep[key], id: key })
    }
  })
})

const activeNames = ref('1')
const searchEle = ref()
const searchObj = reactive({
  userName: '', approvalStatus: '', companyId: '',
})
const searchConfig = ref([
  {
    label: '姓名',
    value: '',
    upKey: 'userName',
  },
  {
    type: 'SELECT',
    label: '状态',
    value: '',
    // value: 'EFFECTIVE',
    upKey: 'approvalStatus',
    options: statusList,
    props: { placeholder: '请选择审批状态', clearable: true },
    seleProps: { label: 'label', valueName: 'id', },
    selectCb: (val: string) => {
      if(!val){
        delete MI_params.query.approvalStatus
      }
      fetchData(MI_params)
    }
  }, 
  cpyCfig({
    selectCb: (val: string) => {
      fetchData(MI_params)
    }
  }),
])

const searchHandle = () => {
  /* if(!params.approvalStatus) {
    delete params.approvalStatus
  } */
  let params: any = {...searchObj}
  if(!params.approvalStatus){
    delete params.approvalStatus
  }
  fetchData({
    query: params
  })
}
searchHandle()

const isShowFile = ref<boolean>(false)
let userContractsList = ref([])
const viewContractHandle = (row: any) => {
  userContractsList.value = row.fileList
  isShowFile.value = true
}

// 下载附件
const donwloadHandle = (row: any) => {
  exportHandle(downloadApi, {fileId: row.fileId, filename: row.filename})
  .then(() => {
    ElMessage.success('下载成功')
  }).catch(() => {
    ElMessage.error('下载错误')
  })
}

const btnLoading = ref<boolean>(false)
// 提交审批
const isShowSubmit = ref<boolean>(false)
let previewSubmitRow: any = reactive({})
const showSubmitHandle = (row: any) => {
  Object.assign(previewSubmitRow, row)
  isShowSubmit.value = true
}

const submitAppriveHandle = () => {
  btnLoading.value = true

  if(statusMap[previewSubmitRow.approvalStatus] === '驳回'){
    reapprovalApi({
      id: previewSubmitRow.id
    }, {contentType: 'formData'}).then(() => {
      fetchData(MI_params)
      isShowSubmit.value = false
      ElMessage.success('重新发起审批成功')
    }).finally(() => {
      btnLoading.value = false
    })
    return
  }
  submit_approvalApi({
    id: previewSubmitRow.id
  }, {contentType: 'formData'}).then(() => {
    fetchData(MI_params)
    isShowSubmit.value = false
    ElMessage.success('提交审批成功')
  }).finally(() => {
    btnLoading.value = false
  })
}

// 发送通知
const isShowNotification = ref<boolean>(false)
let notificationRow: any = reactive({})
const showNotificationHandle = (row: any) => {
  Object.assign(notificationRow, row)
  isShowNotification.value = true
}

const submitNotificationHandle = () => {
  btnLoading.value = true
  submit_approvalApi({
    id: notificationRow.id
  }, {contentType: 'formData'}).then(() => {
    fetchData(MI_params)
    isShowNotification.value = false
    ElMessage.success('发送通知成功')
  }).finally(() => {
    btnLoading.value = false
  })
}

// ---------------切换tab页面---------------
const switchTabs = (row: {employeeName: string}) => {
  emits('ToContract', row.employeeName)
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, {
      modelValue: activeNames.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((activeNames).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "点此搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify),
              model: _unref(searchObj)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "userName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).userName,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).userName) = $event)),
                      class: "form-input",
                      placeholder: "请输入姓名",
                      clearable: "",
                      maxlength: "100",
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchHandle()), ["enter"]))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "状态:",
                  prop: "approvalStatus"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择人员状态",
                      onChange: searchHandle,
                      modelValue: _unref(searchObj).approvalStatus,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).approvalStatus) = $event)),
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statusList), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: item.label,
                            value: item.id,
                            key: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "公司:",
                  prop: "companyId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).companyId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchObj).companyId) = $event)),
                      style: {"width":"310px"},
                      filterable: "",
                      placeholder: "请选择公司",
                      onChange: searchHandle
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysCompany, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            label: group.label,
                            key: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options, (comp) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  label: comp.name,
                                  value: comp.id,
                                  key: comp.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled", "model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 25 + "px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "员工姓名",
          prop: "employeeName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", {
              onClick: ($event: any) => (switchTabs(row))
            }, _toDisplayString(`${row.employeeName}(${row.employeeAlias})`), 9, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "approvalStatus",
          "show-overflow-tooltip": "",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(statusMap)[row.approvalStatus]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动起始日期",
          prop: "startDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动结束日期",
          prop: "endDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动归属公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "劳动合同经办人",
          prop: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.operatorName}(${row.operatorAlias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "合伙人",
          prop: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.leaderId ? `${row.leaderAlias}(${row.leaderName})` : '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "合同类型",
          prop: "category",
          "show-overflow-tooltip": "",
          width: "100",
          formatter: (row) => _unref(categoryMap)('map')[row.category]
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          "show-overflow-tooltip": "",
          width: "300"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          prop: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                (_unref(statusMap)[row.approvalStatus] === '未审批')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (showSubmitHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (_unref(statusMap)[row.approvalStatus] === '驳回')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      onClick: ($event: any) => (showSubmitHandle(row)),
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (!['未审批', '合同生效', '合同已过期'].includes(_unref(statusMap)[row.approvalStatus]) && _unref(statusMap)[row.approvalStatus] !== '驳回')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      onClick: ($event: any) => (showNotificationHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 200, 600],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "附件列表",
      modelValue: isShowFile.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowFile).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          border: "",
          data: _unref(userContractsList)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "文件",
              prop: "filename",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (donwloadHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "提交审批",
      modelValue: isShowSubmit.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((isShowSubmit).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (isShowSubmit.value = false)),
          disabled: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (submitAppriveHandle())),
          loading: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          title: "预览",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "员工姓名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${_unref(previewSubmitRow).employeeName}(${_unref(previewSubmitRow).employeeAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动起始日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(previewSubmitRow).startDate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动结束日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(previewSubmitRow).endDate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动归属公司" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(previewSubmitRow).companyName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动合同经办人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${_unref(previewSubmitRow).operatorName}(${_unref(previewSubmitRow).operatorAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "直属领导" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(previewSubmitRow).leaderId ? `${_unref(previewSubmitRow).leaderAlias}(${_unref(previewSubmitRow).leaderName})` : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(previewSubmitRow).note), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "发送通知",
      modelValue: isShowNotification.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowNotification).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[13] || (_cache[13] = ($event: any) => (isShowNotification.value = false)),
          disabled: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (submitNotificationHandle())),
          loading: btnLoading.value
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          title: "预览",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, { label: "员工姓名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${_unref(notificationRow).employeeName}(${_unref(notificationRow).employeeAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动起始日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(notificationRow).startDate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动结束日期" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(notificationRow).endDate), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动归属公司" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(notificationRow).companyName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "劳动合同经办人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${_unref(notificationRow).operatorName}(${_unref(notificationRow).operatorAlias})`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "直属领导" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(notificationRow).leaderId ? `${_unref(notificationRow).leaderAlias}(${_unref(notificationRow).leaderName})` : '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(notificationRow).note), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})